module.exports = __webpack_public_path__ + "img/year.6c79caff.jpg";